// Sizing for the Specifications maximize modal. Mirrors the PAPI ChatModal sizing block at
// `libs/ai/webui/src/floating-chat-bubble/FloatingChatBubble.module.scss:142-171` (only the
// width / height / max-width / max-height pieces — the PAPI block also handles corner anchoring,
// which doesn't apply here because the modal sits inside react-bootstrap's centered dialog).
//
// Color tokens are absent — Bootstrap CSS variables applied via utility classes in the JSX
// (`bg-body`, `text-body`, `border`) handle theming. Never hardcode hex here.

// 95vw × 92vh on desktop — matches the PAPI maximize size.
.dialogDesktop {
  // Kill the `transform: translate(0, 0)` that react-draggable applies to every modal dialog.
  // For this near-fullscreen maximize modal, dragging is not a real feature (the modal already
  // fills 95% of the viewport), but the transform creates a CSS containing block that breaks
  // `position: fixed` for any descendant — most notably react-select's portaled dropdown menu,
  // which then fails its auto-flip logic and overflows the viewport at the bottom edge. Setting
  // `transform: none` here removes the containing block so menus inside the modal can compute
  // viewport-relative positions correctly. The trade-off (no draggable dialog) is acceptable for
  // a maximize-style modal.
  transform: none !important;

  // `--bs-modal-margin` drives Bootstrap's scrollable-dialog height (`calc(100% - var(--bs-modal-margin) * 2)`), so it must match the margin.
  &.dialogDesktop {
    @media (min-width: 1025px) {
      max-width: 95vw !important;
      width: 95vw;
      --bs-modal-margin: 4vh;
      margin: var(--bs-modal-margin) auto;
    }

    // Tablet: 70vw × 80vh — narrower than desktop so the user keeps a sense of the surrounding chrome.
    @media (min-width: 768px) and (max-width: 1024px) {
      max-width: 80vw !important;
      width: 80vw;
      --bs-modal-margin: 5vh;
      margin: var(--bs-modal-margin) auto;
    }

    // Mobile (defensive): the maximize trigger is hidden via `.maximizeTriggerHiddenOnMobile`, but if
    // the modal is somehow opened on a narrow viewport, render full-screen rather than a tiny dialog.
    @media (max-width: 767px) {
      max-width: 100vw !important;
      width: 100vw;
      margin: 0;
    }
  }
}

// The modal body holds the grid copy. `min-height` gives the grid room to scroll inside the modal
// without the header / footer collapsing on tall content. Computed values that Bootstrap doesn't
// expose as utilities — e.g. "92vh minus header chrome" — go here, not inline.
.body {
  min-height: 70vh;
  max-height: 84vh;
  overflow: auto;

  @media (min-width: 768px) and (max-width: 1024px) {
    min-height: 60vh;
    max-height: 72vh;
  }

  @media (max-width: 767px) {
    min-height: calc(100vh - 7rem);
    max-height: calc(100vh - 7rem);
  }
}
